import React from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useAuthenticationContext} from "./AuthenticationContext";
import {JwtUtils} from "./JwtUtils";
import {VivoPortal} from "@utils/AppConstants";
import AccessDeniedPage from "@pages/other/error_pages/AccessDeniedPage";

export interface ProtectedRouteProps {
    element: React.ReactElement;
    roleMask?: VivoPortal.EnumMemberGroupAliases;
    labFilter?: number[];
    divisionFilter?: number[];
}

export default function ProtectedRoute({element, roleMask, labFilter, divisionFilter}: ProtectedRouteProps) {
    const {roleMask: userRole, rootModel} = useAuthenticationContext();
    const token = JwtUtils.getToken();
    const userLabId = rootModel?.CurrentUserProfile?.LabId ?? -1;
    const userDivisionId = rootModel?.CurrentUserProfile?.DivisionId ?? -1;
    const location = useLocation();
    const isAuthorized =
        (!roleMask || ((userRole & roleMask) > 0 && !!token))
        &&
        (!labFilter || labFilter.length === 0 || labFilter.includes(userLabId))
        &&
        (!divisionFilter || divisionFilter.length === 0 || divisionFilter.includes(userDivisionId));
    // encodeURIComponent to make it safe for a URL
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    if (isAuthorized)
        return element;
    // user is not authorized
    // ... and not logged in so he must log in
    if (rootModel == null) {
        return <Navigate to={`/login?return_url=${returnUrl}`}/>;
    }
    // user is logged in but not authorized
    return <AccessDeniedPage/> 
    // <Navigate to={`/access-denied`}/>;
}
